module.exports = __webpack_public_path__ + "img/step-two.8a42dd0d.png";